import React, { Children } from "react";
import { Spin } from "antd";
import styles from "./Spinner.module.scss";

export type SpinnerSize = "small" | "large";

export interface ISpinner {
  className?: string;
  size?: SpinnerSize;
  description?: React.ReactNode;
  customIndicator?: React.ReactNode;
  delay?: number;
  isLoading?: boolean;
  children?: React.ReactNode;
}
export const Spinner: React.FC<ISpinner> = ({
  className,
  size,
  description,
  customIndicator,
  delay,
  isLoading,
  children,
}) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <Spin
        size={size}
        tip={description}
        indicator={customIndicator}
        delay={delay}
        spinning={isLoading}
      >
        {children ? children : ""}
      </Spin>
    </div>
  );
};
